export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/topic_overview-f7763ee699848a61f2af1f942df45678.svg";